import React, {Component} from 'react';
import * as firebase from 'firebase';
import {Link} from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';


export default class AuthorityPostTable extends Component {
  constructor() {
    super();
    this.state = {
      blog: []
    }
    this.gotData = this.gotData.bind(this);
    this.errData = this.errData.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0,0);
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        var userId = firebase.auth().currentUser.uid
        const postRef = firebase.database().ref('MedicalTeamPosts/').orderByChild('userId').equalTo(userId)
        postRef.once('value', snap => {
          var exists = (snap.val() !== null)
          if(exists) {
            postRef.on('value', this.gotData, this.errData)
          } else {
            console.log('沒有輸入')
          }
        })

      } else {
        window.location = ('/')
      }
    })
  }

  gotData(data) {
  let newProducts = []
  const userdata = data.val();
  const keys = Object.keys(userdata);
  for (let i = 0; i < keys.length; i++) {
    const k = keys[i];
    newProducts.push({
      blogName: userdata[k].blogName,
      blogTag: userdata[k].blogTag,
      createDate: userdata[k].createDate,
      createTime: userdata[k].createTime,
      value: userdata[k].value,
      id: userdata[k].id
    });
  }
  this.setState({blog: newProducts});
  }

  errData(err) {
   console.log(err);
  }

  buttonFormatter(id, post) {
    const location = {
      pathname: `/AuthorityBlogs/${post.id}`,
      state: { fromDashboard: true }
    }
    return  <Link to={location} target='_blank' >查看文章</Link>
  }

  editFormatter(id, post) {
    const location = {
      pathname: `/UserProfile/EditAuthorityPost/${post.id}`,
      state: { fromDashboard: true }
    }
    return  <Link to={location}>編輯文章</Link>
  }

  render() {
    return(
      <div>
        <MetaTags>
            <title>草學藥事 || 管理文章</title>
            <meta id="og-title" property="og:title" content="管理文章" />
        </MetaTags>
       <h1>管理部落格文章</h1>
       <BootstrapTable
        ref='table'
        data={ this.state.blog }
        bodyContainerClass='table-responsive'
        pagination={ true }
        search={ true }
        >
        <TableHeaderColumn dataField='blogName' isKey={true} dataSort={ true }>Blog名稱</TableHeaderColumn>
        <TableHeaderColumn dataField='blogTag' dataSort={ true }>分類</TableHeaderColumn>
        <TableHeaderColumn dataField='createDate' dataSort={ true }>日期</TableHeaderColumn>
        <TableHeaderColumn dataField='createTime' dataSort={ true }>時間</TableHeaderColumn >
        <TableHeaderColumn dataSort={ true } dataFormat={this.buttonFormatter}>文章內容</TableHeaderColumn>
        <TableHeaderColumn dataSort={ true } dataFormat={this.editFormatter}>編輯文章</TableHeaderColumn>
       </BootstrapTable>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/post/AuthorityPostTable.js